import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList, Folder, Users } from 'lucide-react';

const HodDoctorsNav = ({ isHovered = true, styles = {}, onToggle }) => {
     const [adminOpen, setAdminOpen] = useState(false);

     const linkStyle = (isActive) => {
          return {
               ...styles.navItem,
               ...(isActive ? (styles.navItemActive || {}) : {}),
          };
     };

     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => linkStyle(isActive)}>
                    <Home size={18} />
                    {isHovered && <span style={{ marginLeft: 8 }}>Dashboard</span>}
               </NavLink>

               <NavLink to="/employee-attendance" style={({ isActive }) => linkStyle(isActive)}>
                    <ClipboardList size={16} />
                    {isHovered && <span style={{ marginLeft: 8 }}>Doctors Attendance</span>}
               </NavLink>

               {/* regularize */}
               {/* <NavLink to="/regularize" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>Regularize Requests</span>}
               </NavLink> */}

               <NavLink to="/dutyroster" style={({ isActive }) => linkStyle(isActive)}>
                    <CalendarCheck size={16} />
                    {isHovered && <span style={{ marginLeft: 8 }}>Duty Roster</span>}
               </NavLink>

               <NavLink to="/dutyrosterbulk" style={({ isActive }) => linkStyle(isActive)}>
                    <Folder size={16} />
                    {isHovered && <span style={{ marginLeft: 8 }}>Duty Roster Bulk</span>}
               </NavLink>
               <NavLink to="/citywise-on-duty-doctors" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span>Doctors On Duty</span>}
               </NavLink>
               <NavLink to="/citywise-on-duty-doctors-new" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span style={{ marginLeft: '12px' }}>Doctors On Duty New</span>}
               </NavLink>

               <NavLink
                    to="/manager-radiology-assessment"
                    style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}
               >
                    <ClipboardList size={20} />
                    {isHovered && <span style={{ marginLeft: '12px', fontSize: 12, fontWeight: 400 }}>Radiology Assessment - HOD</span>}
               </NavLink>
               {/* /doctor-attendance-summary */}
               <NavLink to="/doctor-attendance-summary" style={({ isActive }) => linkStyle(isActive)}>
                    <CalendarCheck size={16} />
                    {isHovered && <span style={{ marginLeft: 8 }}>Doctor Attendance Summary</span>}
               </NavLink>
          </>
     );
};

// legacy wrapper for code that calls the nav as a function (backwards compatible)
export const hodDoctorsNav = (isHovered, styles, onToggle) => {
     return <HodDoctorsNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default HodDoctorsNav;